/** String id for API/query keys when `_id` may be a Mongo extended JSON `{ $oid }` object. */
export function normalizeIdeaIdForQuery(raw: unknown): string {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'object' && raw !== null && '$oid' in (raw as Record<string, unknown>)) {
    return String((raw as { $oid: string }).$oid);
  }
  return String(raw).trim();
}
